<form [formGroup]="form" (ngSubmit)="formService.submit()">

    <div class="page_title">

        <div class="row marges">

            <div class="col y_items_center">
                <h1 class="title">{{ 'quotation.read.value' | translate }}</h1>
            </div>

            <div class="col_content y_items_center">

                <!-- Retour à la liste des suivis de commande -->

                <button class="btn_cta btn_lines btn_little" type="button" (click)="redirectToList()">
                    {{ 'quotation.list.back.value' | translate }}
                </button>

                <ng-container *ngIf="updateAllowed">

                    <!-- Soumission -->

                    <button class="btn_cta btn_little" type="submit">
                        {{ 'form.submit.action.value'|translate }}
                    </button>

                </ng-container>

            </div>

        </div>

    </div>

    <!-- Gestion des onglets -->

    <mat-tab-group>
        <mat-tab [label]="'generalData.value' | translate">
            <ng-container *ngTemplateOutlet="generalData"></ng-container>
        </mat-tab>
        <mat-tab [label]="'quotation.data.plural.value' | translate">
            <ng-container *ngTemplateOutlet="quotationData"></ng-container>
        </mat-tab>
        <mat-tab [label]="'creator.selected.plural.follow.value' | translate" *ngIf="displayOfferCreators">
            <ng-container *ngTemplateOutlet="offerCreatorCoordinates"></ng-container>
        </mat-tab>
    </mat-tab-group>

</form>

<ng-template #generalData>

    <ng-container [formGroup]="form">

        <div class="form_part limited">

            <mat-accordion class="gradient">
                <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ 'quotation.follow.mine.value' | translate }}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>

                        <ng-container *ngIf="userService.hasRole(currentUser, 'ROLE_OFFER_CREATOR') && !isMine">

                            <!-- Statut créateur d'offres -->

                            <div class="ligne_form row marges">

                                <div class="col_12 form-group">

                                    <div class="framed_green">

                                        <p class="read">
                                            <strong>{{ 'offerCreator.status.value' | translate }}</strong>
                                        </p>

                                        <br/>

                                        <div class="form-group">

                                            <div class="radio">
                                                <input type="radio" [value]="'reply'" formControlName="offerCreatorStatus" class="form-control" id="offerCreatorStatusReply">
                                                <label for="offerCreatorStatusReply">{{ 'status.reply.action.mine.value' | translate }}</label>
                                            </div>

                                            <div class="radio">
                                                <input type="radio" [value]="'no-reply'" formControlName="offerCreatorStatus" class="form-control" id="offerCreatorStatusNoReply">
                                                <label for="offerCreatorStatusNoReply">{{ 'status.no-reply.action.mine.value' | translate }}</label>
                                            </div>

                                            <ng-container *ngIf="form.get('offerCreatorStatus').value === 'reply'">
                                                <span class="message-help"><mat-icon>info</mat-icon>{{ 'quotation.status.reply.help.value' | translate }}</span>
                                            </ng-container>

                                            <ng-container *ngIf="form.get('offerCreatorStatus').value === 'no-reply'">
                                                <span class="message-help"><mat-icon>info</mat-icon>{{ 'quotation.status.no-reply.help.value' | translate }}</span>
                                            </ng-container>

                                        </div>

                                    </div>
                                </div>
                            </div>

                            <ng-container *ngIf="form.get('offerCreatorStatus').value === 'no-reply'">

                                <div class="ligne_form row marges">

                                    <div class="col_12">

                                        <div class="form-group">

                                            <textarea placeholder=" " class="form-control" formControlName="offerCreatorNoReplyReason" id="offerCreatorNoReplyReason"></textarea>
                                            <label for="offerCreatorNoReplyReason">{{ 'noReply.reason.value' | translate }}</label>
                                            <mat-error *ngIf="form.get('offerCreatorNoReplyReason').errors && (form.get('offerCreatorNoReplyReason').dirty || form.get('offerCreatorNoReplyReason').touched)">
                                                <div class="invalid-feedback">
                                                    <div *ngIf="form.get('offerCreatorNoReplyReason').errors.isRequired">{{ 'form.control.error.required.value' | translate }}</div>
                                                    <div *ngIf="form.get('offerCreatorNoReplyReason').errors.maxLength">{{ 'form.control.error.maxLength.value' | translate: { maxLength : maxLengthOfferCreatorRefusalReason } }}</div>
                                                </div>
                                            </mat-error>

                                        </div>
                                    </div>
                                </div>

                            </ng-container>

                            <!-- Collaborateur en charge de la demande -->

                            <div class="ligne_form row_marges">

                                <div class="col_12">

                                    <div class="form-group">

                                        <p class="read">
                                            <strong>{{ 'quotation.offerCreator.responsibleUser.value' | translate }}</strong>
                                        </p>

                                        <div style="margin-top: 12px">
                                            <app-core-select-search [configuration]="collaboratorSearchConfiguration" [sourceCallback]="collaboratorSearchSourceCallback" [formGroupReference]="form" [formControlNameReference]="'offerCreatorResponsibleUser'"></app-core-select-search>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <ng-container *ngIf="!!currentOfferCreatorResponsibleUser">

                                <div class="ligne_form row marges">

                                    <div class="col_12">

                                        <div class="bloc_recap">

                                            <div class="form-group">

                                                <!-- ID -->

                                                <ng-container *ngIf="currentOfferCreatorResponsibleUser?.id">

                                                    <p class="read">
                                                        <strong>{{ 'collaborator.id.value' | translate }} : </strong>
                                                        {{ currentOfferCreatorResponsibleUser?.id }}
                                                    </p>

                                                </ng-container>

                                                <!-- Nom -->

                                                <ng-container *ngIf="currentOfferCreatorResponsibleUser?.firstName || currentOfferCreatorResponsibleUser?.lastName">

                                                    <p class="read">
                                                        <strong>{{ 'collaborator.name.value' | translate }} : </strong>
                                                        {{ currentOfferCreatorResponsibleUser?.firstName }} {{ currentOfferCreatorResponsibleUser?.lastName }}
                                                    </p>

                                                </ng-container>

                                                <!-- Service -->

                                                <ng-container *ngIf="currentOfferCreatorResponsibleUser?.service">

                                                    <p class="read">
                                                        <strong>{{ 'collaborator.service.value' | translate }} : </strong>
                                                        {{ currentOfferCreatorResponsibleUser?.service }}
                                                    </p>

                                                </ng-container>

                                                <!-- Email -->

                                                <ng-container *ngIf="currentOfferCreatorResponsibleUser?.email">

                                                    <p class="read">
                                                        <strong>{{ 'collaborator.email.value' | translate }} : </strong>
                                                        {{ currentOfferCreatorResponsibleUser?.email }}
                                                    </p>

                                                </ng-container>

                                                <!-- Téléphone -->

                                                <ng-container *ngIf="currentOfferCreatorResponsibleUser?.switchboardPhone">

                                                    <p class="read">
                                                        <strong>{{ 'collaborator.phone.value' | translate }} : </strong>
                                                        {{ currentOfferCreatorResponsibleUser?.switchboardPhone }}
                                                    </p>

                                                </ng-container>

                                                <!-- Adresse -->

                                                <ng-container *ngIf="currentOfferCreatorResponsibleUser?.address">

                                                    <p class="read">
                                                        <strong>{{ 'collaborator.address.value' | translate }} : </strong>
                                                        {{ currentOfferCreatorResponsibleUser?.address.address }}, {{ currentOfferCreatorResponsibleUser?.address.zipcode }} {{ currentOfferCreatorResponsibleUser?.address.city }}
                                                    </p>

                                                </ng-container>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </ng-container>

                        </ng-container>

                        <div class="ligne_form row marges">
                            <div class="col_12">
                                <div class="form-group">

                                    <!-- Référence -->

                                    <p class="read">
                                        <strong>{{ 'reference.value' | translate }} : </strong>
                                        {{ quotation.ownerReference }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="ligne_form row marges">
                            <div class="col_12">
                                <div class="form-group">

                                    <!-- N° de dossier -->

                                    <p class="read">
                                        <strong>{{ 'folder.numero.tywin.value' | translate }} : </strong>
                                        <ng-container *ngIf="quotation.reference; else uninformed">
                                            {{ quotation.reference }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="ligne_form row marges">
                            <div class="col_12">
                                <div class="form-group">

                                    <!-- Date de la demande -->

                                    <p class="read">
                                        <strong>{{ 'request.date.value' | translate }} : </strong>
                                        {{ quotation.createdAt | date : 'shortDate' : null : localeId }}
                                    </p>

                                </div>
                            </div>
                        </div>

                        <div class="ligne_form row marges">
                            <div class="col_12">
                                <div class="form-group">

                                    <!-- Date limite de réponse -->

                                    <p class="read">
                                        <strong>{{ 'response.date.limit.value' | translate }} : </strong>
                                        {{ quotation.closedAt | date : 'shortDate' : null : localeId }}
                                    </p>

                                </div>
                            </div>
                        </div>

                        <!-- Statut demande de sur-mesure -->

                        <div class="ligne_form row marges">

                            <div class="col_12">

                                <div class="form-group">
                                    <p class="read">
                                        <strong>{{ 'quotation.status.value' | translate }} :</strong>
                                    </p>

                                </div>
                            </div>
                        </div>

                        <div class="ligne_form row marges">

                            <div class="col_6">

                                <div class="form-group">

                                    <div class="radio">
                                        <input type="radio" [value]="'in-progress'" formControlName="status" class="form-control" id="statusInProgress">
                                        <label for="statusInProgress">{{ 'status.in-progress.value' | translate }}</label>
                                    </div>

                                    <div class="radio">
                                        <input type="radio" [value]="'cancelled'" formControlName="status" class="form-control" id="statusCancelled">
                                        <label for="statusCancelled">{{ 'status.cancelled.value' | translate }}</label>
                                    </div>

                                    <div class="radio">
                                        <input type="radio" [value]="'finished'" formControlName="status" class="form-control" id="statusFinished">
                                        <label for="statusFinished">{{ 'status.finished.value' | translate }}</label>
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <div class="form_part limited">

            <mat-accordion class="gradient">
                <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ (isMine ? 'coordinate.plural.mine.value' : 'transmitter.coordinate.value') | translate }}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>

                        <div class="ligne_form row marges col_12">

                            <div class="col_12">

                                <div class="bloc_recap">

                                    <div class="form-group">

                                        <!-- Nom de l'émetteur -->

                                        <p class="read">
                                            <strong>{{ 'transmitter.name.value' | translate }} : </strong>
                                            {{ quotation.society.name }}
                                        </p>

                                        <ng-container *ngIf="(isMine || (userService.hasRole(currentUser, 'ROLE_OFFER_CREATOR') && !isMine && (currentQuotationOfferCreator.status === 'reply')) || userService.hasOneOfThisRoles(currentUser, ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN']))">

                                            <!-- Email de l'émetteur -->

                                            <p class="read">
                                                <strong>{{ 'transmitter.email.value' | translate }} : </strong>
                                                <ng-container *ngIf="quotation.society.email; else uninformed">
                                                    {{ quotation.society.email }}
                                                </ng-container>
                                            </p>

                                            <!-- Téléphone de l'émetteur -->

                                            <p class="read">
                                                <strong>{{ 'transmitter.phone.value' | translate }} : </strong>
                                                <ng-container *ngIf="quotation.society.phone; else uninformed">
                                                    {{ quotation.society.phone }}
                                                </ng-container>
                                            </p>

                                        </ng-container>

                                    </div>

                                    <div class="form-group">

                                        <p class="read">
                                            <strong class="subtitle_green">{{ 'request.collaborator.transmitter' | translate }}</strong>
                                        </p>

                                        <div style="margin-top: 12px">
                                            <app-core-select-search [configuration]="collaboratorSearchConfiguration" [sourceCallback]="collaboratorSearchSourceCallback" [formGroupReference]="form" [formControlNameReference]="'responsibleUser'"></app-core-select-search>
                                        </div>

                                        <mat-error *ngIf="form.get('responsibleUser').invalid && (form.get('responsibleUser').dirty || form.get('responsibleUser').touched)">

                                            <div class="invalid-feedback">

                                                <div *ngIf="form.get('responsibleUser').errors.required">{{ 'form.control.error.required.value' | translate }}</div>

                                            </div>

                                        </mat-error>

                                    </div>

                                    <ng-container *ngIf="!!currentResponsibleUser">

                                        <div class="form-group">

                                            <!-- ID -->

                                            <ng-container *ngIf="currentResponsibleUser?.id">

                                                <p class="read">
                                                    <strong>{{ 'collaborator.id.value' | translate }} : </strong>
                                                    {{ currentResponsibleUser?.id }}
                                                </p>

                                            </ng-container>

                                            <!-- Nom -->

                                            <ng-container *ngIf="currentResponsibleUser?.firstName || currentResponsibleUser?.lastName">

                                                <p class="read">
                                                    <strong>{{ 'collaborator.name.value' | translate }} : </strong>
                                                    {{ currentResponsibleUser?.firstName }} {{ currentResponsibleUser?.lastName }}
                                                </p>

                                            </ng-container>

                                            <!-- Service -->

                                            <ng-container *ngIf="currentResponsibleUser?.service">

                                                <p class="read">
                                                    <strong>{{ 'collaborator.service.value' | translate }} : </strong>
                                                    {{ currentResponsibleUser?.service }}
                                                </p>

                                            </ng-container>

                                            <!-- Email -->

                                            <ng-container *ngIf="(isMine || (userService.hasRole(currentUser, 'ROLE_OFFER_CREATOR') && !isMine && (currentQuotationOfferCreator.status === 'reply')) || userService.hasOneOfThisRoles(currentUser, ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'])) && currentResponsibleUser?.email">

                                                <p class="read">
                                                    <strong>{{ 'collaborator.email.value' | translate }} : </strong>
                                                    {{ currentResponsibleUser?.email }}
                                                </p>

                                            </ng-container>

                                            <!-- Téléphone -->

                                            <ng-container *ngIf="(isMine || (userService.hasRole(currentUser, 'ROLE_OFFER_CREATOR') && !isMine && (currentQuotationOfferCreator.status === 'reply')) || userService.hasOneOfThisRoles(currentUser, ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'])) && currentResponsibleUser?.switchboardPhone">

                                                <p class="read">
                                                    <strong>{{ 'collaborator.phone.value' | translate }} : </strong>
                                                    {{ currentResponsibleUser?.switchboardPhone }}
                                                </p>

                                            </ng-container>

                                            <!-- Adresse -->

                                            <ng-container *ngIf="(isMine || (userService.hasRole(currentUser, 'ROLE_OFFER_CREATOR') && !isMine && (currentQuotationOfferCreator.status === 'reply')) || userService.hasOneOfThisRoles(currentUser, ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'])) && currentResponsibleUser?.address">

                                                <p class="read">
                                                    <strong>{{ 'collaborator.address.value' | translate }} : </strong>
                                                    {{ currentResponsibleUser?.address.address }}, {{ currentResponsibleUser?.address.zipcode }} {{ currentResponsibleUser?.address.city }}
                                                </p>

                                            </ng-container>

                                        </div>

                                    </ng-container>

                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

    </ng-container>

</ng-template>

<ng-template #quotationData>

    <div class="form_part limited">
        <mat-accordion class="gradient">
            <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{ 'generalData.value' | translate }}</mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <div class="row marges ligne_form">
                        <div class="col_12 col_md_6">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'customer.target.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="quotation.configuration.customerTypology; else uninformed">
                                            {{ translationService.getFallbackTranslation(quotation.configuration.customerTypology.translations).name }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col_12 col_md_6">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'giftVoucher.format.question.value' | translate }}</p>
                                    <p>
                                        {{ (quotation.configuration.allowGiftVoucher ? 'yes.value' : 'no.value') | translate }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <div class="form_part limited">
        <mat-accordion class="gradient">
            <mat-expansion-panel [expanded]="false">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{ 'quotation.read.data.dates' | translate }}</mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <div class="row marges ligne_form">
                        <div class="col_12 col_md_6">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'destination.plural.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="regions.length; else uninformed">
                                            {{ parsedAttributes(regions) }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col_12 col_md_6">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'stay.date.plural.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="(quotation.composition.dateStart && quotation.composition.dateEnd); else uninformed">
                                            {{ moment(quotation.composition.dateStart).format('L') }} - {{ moment(quotation.composition.dateEnd).format('L') }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row marges ligne_form">
                        <div class="col_12 col_md_6">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'dates.plural.flexibility.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="quotation.composition.flexibility; else uninformed">
                                            {{ translationService.getFallbackTranslation(quotation.composition.flexibility.translations).label }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col_12 col_md_6">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'offer.booking.stay.duration.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="quotation.composition.duration; else uninformed">
                                            {{ translationService.getFallbackTranslation(quotation.composition.duration.translations).label }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <div class="form_part limited">
        <mat-accordion class="gradient">
            <mat-expansion-panel [expanded]="false">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{ 'quotation.read.data.count' | translate }}</mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <div class="row marges ligne_form">
                        <div class="col_12 col_md_6">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'adult.count.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="quotation.composition.nbAdult; else uninformed">
                                            {{ quotation.composition.nbAdult }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col_12 col_md_6">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'child.count.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="quotation.composition.nbChild; else uninformed">
                                            {{ quotation.composition.nbChild }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'quotation.composition.comment.description.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="quotation.composition.childrenAgeComment; else uninformed">
                                            {{ quotation.composition.childrenAgeComment }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <div class="form_part limited">
        <mat-accordion class="gradient">
            <mat-expansion-panel [expanded]="false">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{ 'quotation.read.data.budget' | translate }}</mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <div class="row marges ligne_form">
                        <div class="col_12 col_md_6">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'currency.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="quotation.pricing.currency; else uninformed">
                                            {{ translationService.getFallbackTranslation(quotation.pricing.currency.translations).label }} ({{ quotation.pricing.currency.symbol }})
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col_12 col_md_6">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'client.mine.budget.max.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="(quotation.pricing.currency && quotation.pricing.budget); else uninformed">
                                            {{ quotation.pricing.budget }} {{ quotation.pricing.currency.symbol }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'quotation.pricing.comment.description.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="quotation.pricing.comment; else uninformed">
                                            {{ quotation.pricing.comment }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <div class="form_part limited">
        <mat-accordion class="gradient">
            <mat-expansion-panel [expanded]="false">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{ 'quotation.read.data.wish' | translate }}</mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <div class="row marges ligne_form">
                        <div class="col_12 col_md_4">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'restoration.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="quotation.configuration.restoration; else uninformed">
                                            {{ translationService.getFallbackTranslation(quotation.configuration.restoration.translations).label }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col_12 col_md_4">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'activity.plural.payable.wish.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="quotation.configuration.activities.length; else uninformed">
                                            {{ parsedAttributes(quotation.configuration.activities) }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col_12 col_md_4">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'accommodation.plural.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="quotation.configuration.accommodations.length; else uninformed">
                                            {{ parsedAttributes(quotation.configuration.accommodations) }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'quotation.configuration.accommodationsComment.description.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="quotation.configuration.accommodationsComment; else uninformed">
                                            {{ quotation.configuration.accommodationsComment }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'quotation.configuration.transportComment.description.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="quotation.configuration.transportComment; else uninformed">
                                            {{ quotation.configuration.transportComment }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <div class="form_part limited">
        <mat-accordion class="gradient">
            <mat-expansion-panel [expanded]="false">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{ 'insurance.value' | translate }}</mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <div class="row marges ligne_form">
                        <div class="col_12 col_md_6">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'quotation.insurance.value' | translate }}</p>
                                    <p>
                                        {{ (quotation.configuration.hasInsurance ? 'yes.value' : 'no.value') | translate }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col_12 col_md_6">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'insurance.type.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="quotation.configuration.insuranceComment; else uninformed">
                                            {{ quotation.configuration.insuranceComment }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <div class="form_part limited">
        <mat-accordion class="gradient">
            <mat-expansion-panel [expanded]="false">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{ 'quotation.read.data.more' | translate }}</mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <div class="row marges ligne_form">
                        <div class="col_12 col_md_4">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'client.mine.language.spoken.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="quotation.customer.spokenLanguage; else uninformed">
                                            {{ 'locale.' + quotation.customer.spokenLanguage + '.value' | translate }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col_12 col_md_4">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'language.spoken.other.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="quotation.customer.otherSpokenLanguages; else uninformed">
                                            {{ quotation.customer.otherSpokenLanguages }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col_12 col_md_4">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'client.country.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="(quotation.customer.country && getCountryByCode(quotation.customer.country)); else uninformed">
                                            {{ translationService.getFallbackTranslation(getCountryByCode(quotation.customer.country).translations).name }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="bloc_recap">
                                <div class="ck-content">
                                    <p class="titre_h4 highlight">{{ 'quotation.customer.comment.description.value' | translate }}</p>
                                    <p>
                                        <ng-container *ngIf="quotation.customer.comment; else uninformed">
                                            {{ quotation.customer.comment }}
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

</ng-template>

<ng-template #offerCreatorCoordinates>

    <div class="ligne_form row" *ngFor="let offerCreator of quotation.offerCreators">
        <div class="col_12 col_md_6">
            <div class="bloc_recap">
                <div class="form-group">
                    <p class="read">
                        <strong>{{ 'offerCreator.name.value' | translate }} : </strong>
                        {{ offerCreator.offerCreator.name }}
                    </p>

                    <p class="read">
                        <strong>{{ 'phone.value' | translate }} : </strong>
                        {{ offerCreator.offerCreator.phone }}
                    </p>

                    <p class="read">
                        <strong>{{ 'status.value' | translate }} : </strong>
                        {{ ('offerCreator.status.' + offerCreator.status + '.value' | translate) }}
                    </p>

                    <ng-container *ngIf="offerCreator.noReplyReason">

                        <p class="read">
                            <strong>{{ 'noReply.reason.value' | translate }} : </strong>
                            {{ offerCreator.noReplyReason }}
                        </p>

                    </ng-container>
                </div>
            </div>
        </div>
    </div>

</ng-template>

<ng-template #uninformed>{{ 'uninformed.value' | translate }}</ng-template>
